import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {InitialsApartmentDocument} from '@accounting/_common/models/accounting-initials.models';

export const LoadList = createAction(
    '[InitialsApartments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[InitialsApartments] Load List Success',
    props<{ payload: { items: InitialsApartmentDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[InitialsApartments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetLoading = createAction(
    '[InitialsApartments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[InitialsApartments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[InitialsApartments] Update Item Success',
    props<{ payload: InitialsApartmentDocument }>()
);

export const DeleteItem = createAction(
    '[InitialsApartments] Delete Item',
    props<{ payload: InitialsApartmentDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[InitialsApartments] Delete Item Success',
    props<{ payload: InitialsApartmentDocument }>()
);

export const DeleteItemFailure = createAction(
    '[InitialsApartments] Delete Item Failure',
    props<{ payload: InitialsApartmentDocument }>()
);

export const SetInitialState = createAction(
    '[InitialsApartments] Set Initial State'
);
